import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { COLORS } from '../../../constants/colors.js';
import { VARIANTS } from '../../../constants/variants.js';
import modules_441c7b04 from '../styles/Badge.module.less.js';

/**
 * @description The Badge component is label with a background color
 *
 * @component
 * @example
 * ```jsx
 * <Badge color="green">Личные финансы</Badge>
 * ```
 */
const Badge = React.forwardRef((props, ref) => {
    const { text, variant, color, shape, placement, className, children, ...restProps } = props;
    const cx = useStyles(modules_441c7b04);
    const hasChildren = children !== undefined;
    const classNames = cx(className, 'container');
    const elementClassNames = cx('element', {
        [`color-${color}-${variant}`]: true,
        [`shape-${shape}`]: shape && text,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'shape-dot': !text,
        floating: hasChildren,
        [`floating-${placement}`]: hasChildren,
    });
    return (React.createElement("span", { ref: ref, "data-qa": "Badge", className: classNames, ...restProps },
        children,
        React.createElement("span", { className: elementClassNames }, text)));
});
Badge.defaultProps = {
    variant: VARIANTS.SECONDARY,
    color: COLORS.DARK,
    shape: 'round',
    placement: 'top-end',
};
Badge.displayName = 'Badge';

export { Badge };
//# sourceMappingURL=Badge.js.map
